import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { enviarEncuesta } from '../../../store/actions/encuestas';
import base from '../../../containers/Encuestas/EncuestasPrincipal.css';

const BotonEnviar = ({ respuestas, datosCrudos, habilitarBotonEnviar }) => {
  const dispatch = useDispatch();
  const hashEncuesta = useSelector((s) => s.encuestas.hashEncuesta);
  const envioFallido = useSelector((s) => s.encuestas.envioFallido);
  const detalleEnvio = useSelector((s) => s.encuestas.detalleEnvio);

  const handleEnviar = () => {
    dispatch(enviarEncuesta(respuestas, datosCrudos || '', hashEncuesta));
  };

  return (
    <div>
      {envioFallido === 1 && (
        <div style={{ color: 'var(--rojo-claro)', fontSize: '13px', marginBottom: '8px' }}>
          <p style={{ margin: 0 }}>Se produjo un error al enviar la respuesta:</p>
          <p style={{ margin: 0 }}>{detalleEnvio}</p>
        </div>
      )}
      <button type="button" className={`${base.btn} ${base.prim}`} disabled={!habilitarBotonEnviar} onClick={handleEnviar}>
        Enviar ✓
      </button>
    </div>
  );
};

export default BotonEnviar;
